import { render, staticRenderFns } from "./RespondentBreakdown.vue?vue&type=template&id=19a2a7b2&scoped=true"
import script from "./RespondentBreakdown.vue?vue&type=script&lang=js"
export * from "./RespondentBreakdown.vue?vue&type=script&lang=js"
import style0 from "./RespondentBreakdown.vue?vue&type=style&index=0&id=19a2a7b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a2a7b2",
  null
  
)

export default component.exports